<cdx-slotted-modal (close)="close()">
	<h1 modal-header i18n="@@editContactNumbers-heading">Edit contact numbers</h1>
	<div modal-content>
		<form [formGroup]="phoneNumbers" cdxForm #form novalidate>
			<section *ngFor="let phoneNumber of phoneNumbers$ | async">
				<form-input [successIcon]="true" [formControlName]="getControlName(phoneNumber.label)">
					<label attr.data-cy="{{ phoneNumber.label }}" for="phoneNumber-{{ phoneNumber.label }}" label>
						{{ phoneNumber.label }} phone
					</label>
					<form-input-error validation [control]="getControlName(phoneNumber.label)">
						<p
							attr.data-cy="{{ phoneNumber.label }}-error"
							[cdxInvalidType]="'required'"
							i18n="@@editContactNumbers-requiredPhoneNumberErrorMessage"
						>
							At least one phone number is required.
						</p>
						<p
							attr.data-cy="{{ phoneNumber.label }}-error"
							[cdxInvalidType]="'pattern'"
							i18n="@@editContactNumbers-invalidPhoneNumberErrorMessage"
						>
							Please enter a valid phone Number.
						</p>
						<p
							attr.data-cy="{{ phoneNumber.label }}-error"
							[cdxInvalidType]="'serverError'"
							i18n="@@editContactNumbers-postContactDetailsServerErrorMessage"
						>
							Something went wrong. For further assistance, please call 0800 40 40 40
						</p>
					</form-input-error>
				</form-input>
			</section>
		</form>
	</div>
	<button
		modal-footer-primary
		cdxButton
		fillStyle="primary"
		[disabled]="!form.canSubmit"
		[buttonState]="buttonState"
		(click)="onSubmit()"
		i18n="@@editContactNumbers-confirmBtn"
	>
		Update number
	</button>
</cdx-slotted-modal>
